<template>
  <sub-page
      :title="$t('Settings')"
      v-model="$store.state.settings.pageData"
  >
    Settings will be here
    <ws-data-table
        :items="items"
        :headers="headers"
    >

    </ws-data-table>

  </sub-page>
</template>

<script>
export default {
  name: "Tasks",
  data() {
    return {
      items : [
        { name : 'Docuemnt_1' , date : 12312333  },
        { name : 'Mega new project' , date : 12312333  }
      ]
    }
  },
  computed : {
    headers() {
      return [
        { text : this.$t('Name') , value : 'name' },
        { text : this.$t('Date') , value : 'date' }
      ]
    }
  }
}
</script>

<style scoped>

</style>